import React, { useCallback, useEffect } from 'react'
import _ from 'lodash'
import camelcaseKeys from 'camelcase-keys'
import { OmnitechApi } from '../../api'
import createPersistedState from './create-persisted-state'
import CacheChecksumContext from './cache-checksum-context'
import config from '../../config'

const useCacheChecksum = createPersistedState('cacheChecksum')

export default function withCacheChecksum (WrappedComponent) {
  return function CacheChecksumProvider(props) {
    const [cacheChecksum, setCacheChecksum] = useCacheChecksum({})

    useEffect(() => {
      OmnitechApi.client.interceptors.response.use(response => {
        let newChecksum = camelcaseKeys(_.get(response, 'data.cache_checksum', {}), { deep: true })

        // get system settings checksum from config
        const systemSettingsUrl = config.get('api.systemSettingsUrl')
        const systemSettingsChecksum = config.get('api.systemSettingsChecksum')
        if (!_.isEmpty(systemSettingsUrl) && !_.isEmpty(systemSettingsChecksum)) {
          newChecksum = {
            ...newChecksum,
            systemSettingsValue: systemSettingsChecksum,
          }
        }

        if (!_.isEmpty(newChecksum)) {
          setCacheChecksum(newChecksum)
        }
        return response
      })
    }, [])

    const getChecksum = useCallback(
      key => {
        return _.get(cacheChecksum, `${key}Value`)
      },
      [cacheChecksum]
    )

    const state = {
      cacheChecksum,
      getChecksum,
      setCacheChecksum,
    }

    return (
      <CacheChecksumContext.Provider value={state}>
        <WrappedComponent {...props} />
      </CacheChecksumContext.Provider>
    )
  }
}
